import { render, staticRenderFns } from "./Esami.vue?vue&type=template&id=4cb75544&"
import script from "./Esami.vue?vue&type=script&lang=js&"
export * from "./Esami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports